module.exports = __webpack_public_path__ + "static/media/The_Core_Four_A.8eebd547.png";